import {Flex, Text} from '@priority-software/priority-style-react';
import React from 'react';
import {SortIcon} from '../../../../components/Common/SortIcon';
import styles from './styles.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

interface Props {
    onSort: () => void;
    title: string;
    isSortActive: boolean;
    isDesc?: boolean;
    testId: string;
}
const HeaderCol = ({title, isSortActive, onSort, isDesc, testId}: Props) => {
    const dataTestId = testId && createDataTestId(`report-list-col-header-${testId}`);
    return (
        <div onClick={onSort} className={styles.tableHeaderItem} {...dataTestId}>
            <Flex justifyContent="flex-start">
                <Text skin="caption-2" textColor="primary-700">
                    {title}
                </Text>
                <SortIcon isDesc={isDesc} isActive={isSortActive} />
            </Flex>
        </div>
    );
};

export default HeaderCol;
